import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const Web3WalletAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.wallet} />

export default Web3WalletAppDevelopment
